export var FiltersActionTypes;
(function (FiltersActionTypes) {
    FiltersActionTypes["FETCH_FILTERS_ATTEMPT"] = "FETCH_FILTERS_ATTEMPT";
    FiltersActionTypes["FETCH_FILTERS_SUCCESS"] = "FETCH_FILTERS_SUCCESS";
    FiltersActionTypes["FETCH_FILTERS_FAILURE"] = "FETCH_FILTERS_FAILURE";
})(FiltersActionTypes || (FiltersActionTypes = {}));
